const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!re.test(email)) return false;
    if (email.includes("@noemail.internal") || email.startsWith("support+") || email.startsWith("temp-user+")) return false;
    return true;
};

export default validateEmail;
